/**
 * Legacy ZIndex styles, from pre-KM v2 theme rewrite.
 *
 * Note: We need to come up with a holistic stacking organization system.
 * z-index on it's own is not enough to provide guarantees, due to ancestor
 * stacking contexts. A more robust solution for modern React apps leverage
 * portals.
 */ export var legacyZIndex = {
    background: 0,
    ground: 1,
    foreground: 2
};
